import React, { useEffect, useState } from "react";
import "./level.scss";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { BiArrowBack } from "react-icons/bi";
import RichTextEditor from "../../components/RichTextEditor/RichTextEditor";

const AddLevels = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = (queryParams.get("type") ?? "COURSE").toUpperCase();
  // course_type (VFR / IFR) + used_for come from the listing tab the user was on.
  // The backend resolves the actual course_id from these, so there is no longer
  // a "Course Type" dropdown on this form.
  const courseType = queryParams.get("course_type") ?? "";
  const usedFor = (queryParams.get("used_for") ?? "COURSE").toUpperCase();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [loading, setLoading] = useState(false);
  const [loader, setShowLoader] = useState(false);
  const [types, setTypes] = useState<any[]>([]);
  const [data, setData] = useState<any>({});
  const [error, setError] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [description, setDescription] = useState("");
  const [courseUUID, setCourseUUID] = useState("");
  const [isStageCheck, setIsStageCheck] = useState(0);
  useEffect(() => {
    typeList();
    if (id !== "add") userdetails();
  }, []);
useEffect(() => {
  if (types.length > 0 && data?.course_id) {
    setValue("course_id", data.course_id);
  }
}, [types, data]);
  const typeList = () => {
    setLoading(true);
    const usedFor = type;

    WebService.getAPI({
      action: `/courses?type=${usedFor}`,
    })
      .then((res: any) => {
        setLoading(false);
        setTypes(res.list || []);
      })
      .catch((e) => {
        setTypes([]);
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  const getCourseUUID = async (courseId: number) => {
    const found = types.find((x: any) => x.id == courseId)?.uuid;
    if (found) return found;
    try {
      const res: any = await WebService.getAPI({
        action: `/courses/${courseId}`,
      });
      return res?.result?.uuid || null;
    } catch {
      return null;
    }
  };

  const userdetails = () => {
    setLoading(true);

    WebService.getAPI({
      action: `/levels/${id}`,
    })
      .then((res: any) => {
        setLoading(false);
        setData(res.result);

        setValue("title", res.result.title);
        setDescription(res.result.description);
     //   setValue("course_id", res.result.course_id);
        setIsStageCheck(res.result.is_stage_checker);
        setValue("stage_checker_min_proficiency_score", res.result.stage_checker_min_proficiency_score);
        setValue("stage_checker_passing_score", res.result.stage_checker_passing_score);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  // ...existing code...
  const onSave = async (form: any) => {
    const payload = {
      uuid: id,
      title: form.title,
      description,
      course_type: courseType,
      used_for: usedFor,
      is_stage_checker: isStageCheck,
      stage_checker_passing_score : form.stage_checker_passing_score,
      stage_checker_min_proficiency_score : form.stage_checker_min_proficiency_score,

    };

    setShowLoader(true);
    try {
      if (id !== "add") {
        // Update
        const res: any = await WebService.putAPI({
          action: `/levels/edit`,
          body: payload,
        });

        toast.success(res.message);
        // await the async helper so it returns the actual UUID (not a Promise)
        const cuid = await getCourseUUID(res.result.course_id);
        setCourseUUID(cuid);
        setShowLoader(false);

        if (type === "CERTIFICATE" && courseUUID) {
          navigate(`/course-levels/${courseUUID}?type=${type}`);
        } else {
          navigate(`/course-levels?type=${type}`);
        }
      } else {
        // Add
        const addPayload = {
          title: form.title,
          description,
          course_type: courseType,
          used_for: usedFor,
          stage_checker_passing_score : form.stage_checker_passing_score,
          stage_checker_min_proficiency_score : form.stage_checker_min_proficiency_score
        };

        const res: any = await WebService.postAPI({
          action: `/levels/add`,
          body: addPayload,
        });

        toast.success(res.message || "Levels added successfully");
        // await the async helper here as well
        const courseUUID = await getCourseUUID(res.result.course_id);
        setShowLoader(false);

        if (type === "CERTIFICATE" && courseUUID) {
          navigate(`/course-levels/${courseUUID}?type=${type}`);
        } else {
          navigate(`/course-levels?type=${type}`);
        }
      }
    } catch (e: any) {
      setShowLoader(false);
      toast.error(e?.response?.message || "Something went wrong");
      setError(true);
    }
  };

  return (
    <Container className="mt-5">
      {/* BACK BUTTON */}
      <Row className="align-items-center mb-4">
        <Col xs="auto">
          <Link
            to={`/course-levels/${courseUUID}?type=${type}`}
            className="d-flex align-items-center text-decoration-none"
          >
            <BiArrowBack size={22} className="me-2 text-dark" />
            <span className="text-dark">Back</span>
          </Link>
        </Col>

        <Col className="text-center">
          <h1 className="font-20 font-bold m-0">
            {id !== "add" ? "Update Level" : "Add Level"}
          </h1>
        </Col>

        <Col xs="auto"></Col>
      </Row>

      {/* FORM */}
      <Row className="justify-content-center">
        <Col lg={10}>
          <Loader show={loading} />

          <Card className="p-4 shadow-sm">
            <Form onSubmit={handleSubmit(onSave)}>
              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="levelNumber">
                    <Form.Label>Level Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Level"
                      {...register("title", { required: true })}
                    />
                  </Form.Group>

                  {errors.title && (
                    <small className="text-danger">Please enter level</small>
                  )}
                </Col>
              </Row>

              {/* DESCRIPTION */}
              <Row className="mb-4">
                <Col lg={12}>
                  <Form.Group controlId="description">
                    <Form.Label>Description</Form.Label>

                    <RichTextEditor
                      height="250px"
                      value={description}
                      onChange={setDescription}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Course Type is no longer chosen here — it comes from the
                  listing tab (VFR / IFR) and is resolved on the backend. */}

              <Row className="mb-3 mt-5">
                <Col lg={12}>
                  <Form.Group controlId="levelNumber">
                    <Form.Check
                      type="checkbox"
                      id="vfr-check"
                      className="chk-gap me-4"
                      label="Is Check Stage"
                      checked={isStageCheck === 1}
                      onChange={() =>
                        setIsStageCheck(isStageCheck === 1 ? 0 : 1)
                      }
                    />
                  </Form.Group>

                  {errors.title && (
                    <small className="text-danger">Please enter level</small>
                  )}
                </Col>
              </Row>
              {isStageCheck ? (
                <>
                  <Row className="mb-3">
                    <Col lg={6}>
                      <Form.Group controlId="passignScore">
                        <Form.Label>Passign Score</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Passing Score"
                          {...register("stage_checker_passing_score", {
                            required: false,
                          })}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group controlId="minimumProficiencyScore">
                        <Form.Label>Minimum Proficiency Score</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Proficiency Score"
                          {...register("stage_checker_min_proficiency_score", {
                            required: false,
                          })}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}

              {/* SAVE / UPDATE BUTTON */}
              <Button
                type="submit"
                className="btn btn-brand-1 d-block mx-auto mt-3"
                disabled={loader}
              >
                {loader && <Spinner size="sm" className="me-2" />}{" "}
                {id !== "add" ? "Update" : "Save"}
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddLevels;
